import apiClient from 'hub-http/clients/apiClient';
const MEETINGS_ENDPOINT = 'meetings/v1';
const MEETINGS_CUSTOM_REMINDER_EMAIL_ENDPOINT = `${MEETINGS_ENDPOINT}/custom-email/reminder/link`;
export class MeetingsCustomReminderEmailAPI {}
MeetingsCustomReminderEmailAPI.deleteCustomReminderEmail = linkId => apiClient.delete(`${MEETINGS_CUSTOM_REMINDER_EMAIL_ENDPOINT}/${linkId}`);
MeetingsCustomReminderEmailAPI.getCustomReminderEmail = linkId => apiClient.get(`${MEETINGS_CUSTOM_REMINDER_EMAIL_ENDPOINT}/${linkId}`);
MeetingsCustomReminderEmailAPI.putCustomReminderEmail = (linkId, customReminderEmail) => apiClient.put(`${MEETINGS_CUSTOM_REMINDER_EMAIL_ENDPOINT}/${linkId}`, {
  data: customReminderEmail
});